import React from 'react';

interface BookmarkActionsProps {
  bookmarkId: string;
  url: string;
  onDelete: (bookmarkId: string) => void;
  onOpenExternal: (url: string) => void;
  onAddToCollection: (bookmarkId: string) => void;
  onToggleFavorite: (bookmarkId: string) => void;
  variant?: 'card' | 'list';
}

export const BookmarkActions: React.FC<BookmarkActionsProps> = ({
  bookmarkId,
  url,
  onDelete,
  onOpenExternal,
  onAddToCollection,
  onToggleFavorite,
  variant = 'card'
}) => {
  const containerClass = variant === 'card' ? 'bookmark-actions' : 'bookmark-list-actions';

  return (
    <div className={containerClass}>
      <button 
        className="bookmark-action-btn external-link-btn"
        onClick={() => onOpenExternal(url)}
        title="Open in new tab"
      >
        <span role="img" aria-label="external link">↗️</span>
      </button>
      <button 
        className="bookmark-action-btn collection-btn"
        onClick={() => onAddToCollection(bookmarkId)}
        title="Add to collection"
      >
        <span role="img" aria-label="list">📋</span>
      </button>
      <button 
        className="bookmark-action-btn favorite-btn"
        onClick={() => onToggleFavorite(bookmarkId)}
        title="Add to favorites"
      >
        <span role="img" aria-label="favorite">⭐</span>
      </button>
      <button 
        className="bookmark-action-btn delete-btn"
        onClick={() => onDelete(bookmarkId)}
        title="Delete bookmark"
      >
        <span role="img" aria-label="delete">🗑️</span>
      </button>
    </div>
  );
};